<template>
    <transition
        name="slide"
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
    >
        <slot />
    </transition>
</template>

<script>
export default {
    data() {
        return {
            speed: 300
        }
    },
    methods: {
        beforeEnter(el) {
            el.style.maxHeight = 0
            el.style.overflow = 'hidden'
        },
        enter(el, done) {
            el.style.transition = `max-height ${this.speed}ms ease-in-out`
            requestAnimationFrame(() => {
                el.style.maxHeight = el.scrollHeight + 'px'
            })
            setTimeout(done, this.speed)
        },
        afterEnter(el) {
            el.style.maxHeight = ''
        },
        beforeLeave(el) {
            el.style.maxHeight = el.scrollHeight + 'px'
            el.style.overflow = 'hidden'
            requestAnimationFrame(() => {
                el.style.maxHeight = 0
            })
        },
        leave(el, done) {
            el.style.transition = `max-height ${this.speed}ms ease-in-out`
            requestAnimationFrame(() => {
                el.style.maxHeight = 0
            })
            setTimeout(done, this.speed)
        },
        afterLeave(el) {
            el.style.maxHeight = ''
        }
    }
}
</script>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
    transition: max-height 300ms ease-in-out;
}

.slide-enter, .slide-leave-to {
    max-height: 0;
    overflow: hidden;
}
</style>